<template>
  <div class="LetzteRunden" v-if="lastFiveRounds != null && user">
    <h3>Letzte 5 Runden</h3>

    <v-layout>
      <v-flex xs12 class="text-xs-center">
        <v-progress-circular indeterminate class="warning--text" :width="7" :size="70" v-if="loading"></v-progress-circular>
      </v-flex>
    </v-layout>

    <v-layout v-if="!loading">
      <v-flex xs12>
        <v-card>
          <v-card-title primary-title class="pt-2 pb-0">
            <h4 class="mb-1">Bitte Runde auswählen</h4>
          </v-card-title>
          <v-card-text class="pt-0">
            <table>
              <thead>
                <tr>
                  <th style="width: 40%">Datum</th>
                  <th class="tableData">Kurs</th>
                  <th class="tableData">Punkte</th>
                  <th class="tableData">Schläge</th>
                </tr>
              </thead>
              <tbody v-for="round in lastFiveRounds" :key="round.val().roundKey">
                <tr @click.stop="setRound" class="editRow" :id="round.val().roundKey">
                  <td>{{ round.val().datum }}</td>
                  <td>{{ round.val().farbe }}</td>
                  <td>{{ round.val().points }}</td>
                  <td>{{ round.val().score }}</td>
                </tr>
              </tbody>
            </table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    
  </div>
</template>

<script>
export default {
  name: 'LetzteRunden',

  data() {
    return {

    }
    // End Data
  },

  computed: {
    user() {
      return this.$store.getters.user
    },
    lastFiveRounds() {
      return this.$store.getters.lastFiveRounds
    },
    loading() {
      return this.$store.getters.loading
    }
    // End Computed
  },

  methods: {
    setRound(e) {
      if (e.currentTarget.id != null) {
        this.$store.dispatch('setRound', { roundKey: e.currentTarget.id })
        this.$router.push('/')
      }
    }
    // End Methods
  }
}
</script>

<style scoped>
@media (max-width: 667px) {

  .container {
    padding: 5px;
  }
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

td {
  text-align: center;
}

.tableData {
  width: 20%;
}

tr {
  height: 4em;
  border-bottom: 1px solid #d0d0d0;
}

.editRow:hover {
  box-shadow: 0 1px 1px 1px rgba(0, 0, 0, .2);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// LetzteRunden.vue?b93c31c0